import {useFormikContext} from "formik";
import React, {useMemo, useState} from "react";
import {Button} from "react-bootstrap";
import {WhiteCard} from "../_components/WhiteCard";
import {Field} from "formik";
import {Slider} from "../_components/Slider";


export function SoundControl() {
    const [show, setShow] = useState(false)

    return <>
        <WhiteCard>
            <div className="fs-5 fw-semibold">Sound Control</div>

            <VolumeSlider/>

            <Button variant="outline-secondary" className="mt-4" onClick={() => setShow(!show)}>{show ? "Close Equalizer" : "Show Equalizer"}</Button>
            {show && <>
                {/*<div className="fw-medium">Equalizer</div>*/}
                <div className="mt-2"/>
                <TrebleSlider/>
                <div className="mt-4"/>
                <BassSlider/>
            </>}

        </WhiteCard>

    </>
}

function VolumeSlider() {
    const {values} = useFormikContext()

    return <>
        {/*<div className="fw-medium">Volume</div>*/}
        <Field name="volume">
            {({field}) => {
                const volumeLabel = useMemo(() => field.value === 0 ? "Power off" : field.value === 255 ? "No attenuation" : `Volume ${(field.value - 255) * 0.5} dB`, [field.value])
                return <Slider {...field} label={volumeLabel} min="0" max="255" step="1" iconLeft="bi-volume-down"
                               iconRight="bi-volume-up" interval={75} timeout={550}/>
            }}
        </Field>

        {/*<div className="fw-medium">Left/Right Balance</div>*/}
        <Field name="balance">
            {({field}) => {
                const balanceLabel = useMemo(() => field.value === 0 ? "Balance" : field.value < 0 ? `Balance Left ${-field.value}/25` : `Balance Right ${field.value}/25`, [field.value])
                return <Slider {...field} label={balanceLabel} min={-25} max={25} step="1" iconLeft="bi-arrow-left" iconRight="bi-arrow-right"
                               disabled={values.volume === 0} interval={65} timeout={650}/>
            }}
        </Field>
    </>

}

function TrebleSlider() {
    const {values} = useFormikContext()

    return <>
        <Field name="treble_ampl">
            {({field}) => {
                const trebleAmplLabel = useMemo(() => field.value === 0 ? "Treble Off" : `Treble ${field.value > 0 ? "+" : ""}${field.value * 1.5} dB`, [field.value])
                return <Slider {...field} label={trebleAmplLabel} min="-8" max="7" step="1" iconLeft="bi-volume-down" iconRight="bi-volume-up"
                               disabled={values.volume === 0} interval={250} timeout={500}/>
            }}
        </Field>


        <Field name="treble_freq">
            {({field}) => {
                const trebleFreqLabel = useMemo(() => `Treble cut ${field.value} kHz`, [field.value])
                return <Slider {...field} label={trebleFreqLabel} min={1} max={15} step="1" iconLeft="bi-reception-2" iconRight="bi-reception-4"
                               disabled={values.treble_ampl === 0 || values.volume === 0} interval={250} timeout={450}/>
            }}
        </Field>
    </>

}

function BassSlider() {
    const {values} = useFormikContext()

    return <>
        <Field name="bass_ampl">
            {({field}) => {
                const bassAmplLabel = useMemo(() => field.value === 0 ? "Bass Off" : `Bass +${field.value} dB`, [field.value])
                return <Slider {...field} label={bassAmplLabel} min="0" max="15" step="1" iconLeft="bi-volume-down" iconRight="bi-volume-up"
                               disabled={values.volume === 0} interval={250} timeout={450}/>
            }}
        </Field>


        <Field name="bass_freq">
            {({field}) => {
                const bassFreqLabel = useMemo(() => `Bass cut ${field.value * 10}  Hz`, [field.value])
                return <Slider {...field} label={bassFreqLabel} min={2} max={15} step="1" iconLeft="bi-reception-2" iconRight="bi-reception-4"
                               disabled={values.bass_ampl === 0 || values.volume === 0} interval={250} timeout={450}/>
            }}
        </Field>
    </>

}


function rescale(data, minTarget, maxTarget, minData, maxData) {
    const targetRange = maxTarget - minTarget
    const valRange = maxData - minData
    const temp = (data - minData) / valRange
    return Math.round(temp * targetRange + minTarget)
}